export default __webpack_public_path__ + "static/media/Balthus's Woodsman Belt.73a6055f.jpg";